import React, {useEffect} from 'react'
import RadioButtonCheckedIcon from '@material-ui/icons/RadioButtonChecked';
import RadioButtonUncheckedIcon from '@material-ui/icons/RadioButtonUnchecked';
import Form from 'react-bootstrap/Form'
import moment from 'moment-timezone'

function PaymentMethodCell({selected, onClick, paymentMethod}) {

    var view = paymentMethod.id ? (<div>
        <h6 className="my-0">
            <i className="fas fa-credit-card" ></i>
            <span>&nbsp;{paymentMethod.card.brand.toUpperCase()}</span>
            <small>&nbsp;&#183;&#183;&#183;&#183;{paymentMethod.card.last4}</small>
        </h6>
        {/* <p className="mb-0">&#183;&#183;&#183;&#183;{paymentMethod.card.last4}</p> */}
    </div>) : (
        <h6 className="my-0">New Card</h6>
    )

    return (
        <div onClick={onClick} className={`card w-100 my-3 p-2 ${selected ? "border border-primaryColor" : ""}`}>
            <div className="d-flex d-row justify-content-between align-items-center">
                {view}
                {selected ? (
                    <RadioButtonCheckedIcon className="primaryColor" />
                ) : (
                    <RadioButtonUncheckedIcon className="primaryColor" />
                )}
            </div>
            
        </div>

    )
}

function PaymentMethodSelector(props) {

    const {paymentMethods, defaultPaymentMethod} = props
    const models = paymentMethods.concat({})

    const [selectedIndex, setSelectedIndex] = React.useState((paymentMethods && defaultPaymentMethod) ? (paymentMethods.findIndex(val => val.id === defaultPaymentMethod)) : null)

    function selectIndex(index) {
        setSelectedIndex(index)
        const selectedPaymentMethod = paymentMethods[index]
        // setModelSelected(selectedModel)
        if (props.onChange) {
            props.onChange(selectedPaymentMethod)
        }
    }
    useEffect(() => {
        if (selectedIndex === null) {
            var indexToSelect = 0
            models.forEach((val, index) => {
                if (indexToSelect === 0 && val.remaining > 0) {
                    indexToSelect = index
                }
            })
            // console.log("Models 1: ", models)
            selectIndex(indexToSelect)
        }
        
    }, [selectedIndex])

    useEffect(() => {
        if (selectedIndex === null) {
            selectIndex(0)
        } else {
            const selectedPaymentMethod = paymentMethods[selectedIndex]
            
            if (props.onChange) {
                props.onChange(selectedPaymentMethod)
            }
        }
        
    }, [selectedIndex])

    useEffect(() => {
        if (selectedIndex === null) {
            selectIndex(0)    
        }
        
    }, [paymentMethods])
    

    // if model is class
    //   get the price and use dropin == true
    // if model is offering
    //   get the offeringId, use dropin == false
    // if model is purchase
    //    get the purchaseId, use dropIn == false    

    return (
        <div>
            {models.map((val, index) => (
                <PaymentMethodCell
                key={index} 
                selected={selectedIndex === index} 
                onClick={() => selectIndex(index)}
                paymentMethod={val}
                />
            ))}
        </div>

    )
}



export default PaymentMethodSelector